import React from "react";
import { useNavigate } from "react-router-dom";
import { contextapi } from "../../helpers/contextapi";
import { axiospost } from "../../helpers/httprequest";
import swal from "../../helpers/swal";
import { Link } from "react-router-dom";
import { Field, Form, Formik } from "formik";
import { ms_applicant } from "@v2/validators";
import ErrorMessage from "../../components/ErrorMessage";

const Register = () => {
  const context = React.useContext(contextapi);
  const navigate = useNavigate();
  React.useEffect(() => {
    localStorage.clear();
    context.setvalues({ ...context.values, main_menu: undefined });
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const _login = async (values) => {
    try {
      const fname = values.firstname;
      const mname = values.middlename;
      const lname = values.lastname;
      const email = values.emailaddress;
      const phone = values.phonenumber;
      const pword = values.password;
      const jmb = values.jamb;

      const req = await axiospost("ms_applicant", {
        firstname: fname,
        middlename: mname,
        lastname: lname,
        emailaddress: email,
        phonenumber: phone,
        jamb: jmb,
        password: pword,
      });
      if (req.status !== 200) {
        throw new Error("Sorry, system could not finish processing your request");
      }
      const { data } = req;
      if (data && data.type === "success") {
        const { message, type } = data;
        swal(type, message);
        navigate("/verify")
      } else {
        throw new Error(data.message);
      }
    } catch ({ message }) {
      swal("warning", message);
    }
  };
  return (
    <div className="container-scroller">
      <div className="container-fluid page-body-wrapper full-page-wrapper">
        <div className="content-wrapper d-flex align-items-center auth px-0">
          <div className="row w-100 mx-0">
            <div className="col-lg-7 mx-auto">
              <div className="auth-form-light text-left py-3 px-4 px-sm-5">
                <div className="brand-logo text-center mb-3">
                  <img src="images/logo.png" alt="logo" />
                </div>
                <div className="text-center my-5 mt-5">
                  <h4 className="text-uppercase">Kebbi State Polytechnic Dakingari</h4>
                  <h6 className="font-weight-light text-uppercase">Admission Application Portal for Undergraduate</h6>
                  <h6 className="font-weight-light text-uppercase">Create your profile.</h6>
                </div>
                <div className="pt-1">
                  <Formik
                    initialValues={{
                      firstname: "",
                      middlename: "",
                      lastname: "",
                      emailaddress: "",
                      phonenumber: "",
                      jamb: "",
                      password: "",
                      confirmpassword: "",
                    }}
                    validationSchema={ms_applicant.createapplicantrules}
                    initialTouched={{ zip: true }}
                    onSubmit={_login}
                  >
                    {({ isSubmitting, touched, errors }) => (
                      <Form className="my-4">
                        <div className="row">
                          <div className="col-md-4">
                            <ErrorMessage name={"firstname"} label="First name" errors={errors?.firstname} touched={touched?.firstname} />
                          </div>
                          <div className="col-md-4">
                            <div className="form-group form-floating">
                              <Field className="form-control form-control-lg" id="middlename" placeholder="Middle Name" name={"middlename"} />
                              <label htmlFor="middlename">Middle Name</label>
                            </div>
                          </div>
                          <div className="col-md-4">
                            <ErrorMessage name={"lastname"} label="Last name" errors={errors?.lastname} touched={touched?.lastname} />
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-md-4">
                            <ErrorMessage name={"jamb"} label="Jamb Admission Number" errors={errors?.jamb} touched={touched?.jamb} />
                          </div>
                          <div className="col-md-4">
                            <ErrorMessage name={"emailaddress"} label="Email Address" errors={errors?.emailaddress} touched={touched?.emailaddress} />
                          </div>
                          <div className="col-md-4">
                            <ErrorMessage name={"phonenumber"} label="Phone Number" errors={errors?.phonenumber} touched={touched?.phonenumber} />
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-md-6">
                            <ErrorMessage type="password" name={"password"} label="Password" errors={errors?.password} touched={touched?.password} />
                          </div>
                          <div className="col-md-6">
                            <ErrorMessage
                              name={"confirmpassword"}
                              label="Confirm Password"
                              type="password"
                              errors={errors?.confirmpassword}
                              touched={touched?.confirmpassword}
                            />
                          </div>
                        </div>
                        <div className="mt-3">
                          <button disabled={isSubmitting} className="btn btn-block btn-primary btn-lg font-weight-medium auth-form-btn" type="submit">
                            {isSubmitting ? "Please wait..." : "Create Account"}
                          </button>
                        </div>
                        <div className="my-2 d-flex justify-content-between align-items-end">
                          <Link to="/" className="auth-link text-black">
                            Login?
                          </Link>
                          <Link to="/forgot" className="auth-link text-black">
                            Forgot password?
                          </Link>
                        </div>
                      </Form>
                    )}
                  </Formik>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Register;
